import { jsx as e, jsxs as t, Fragment as n } from "react/jsx-runtime";

import { forwardRef as o, useState as i, useRef as r, useCallback as l, useLayoutEffect as s, isValidElement as a, cloneElement as u } from "react";

import { offset as m, flip as c, shift as p, useFloating as d, autoUpdate as f, useClick as g, useRole as x, useDismiss as h, useListNavigation as b, useInteractions as v, useMergeRefs as y, FloatingFocusManager as F, FloatingPortal as w } from "@floating-ui/react";

import N from "../../utils/classNames/index.js";

const k = [ m({
    mainAxis: 4,
    alignmentAxis: 0
}), c(), p() ], C = o((({items: o, prefix: m, suffix: c, portal: p, dirtyZ: C, placement: I = "bottom-start", itemClassName: R, menuRole: P = "menu", opened: j, onOpenChange: A, ...D}, E) => {
    const [M, O] = i(!1), z = "boolean" == typeof j, K = z ? j : M, [Z, q] = i(null), B = "list" === P, G = r([]), H = l((e => {
        z ? A?.(e) : O(e);
    }), []);
    s((() => {
        z && O(j);
    }), [ j ]);
    const {x: J, y: L, strategy: Q, refs: S, context: T} = d({
        open: K,
        onOpenChange: H,
        placement: I,
        middleware: k,
        whileElementsMounted: f
    }), U = g(T, {
        event: "mousedown"
    }), V = x(T, {
        role: "menu"
    }), W = h(T), X = b(T, {
        listRef: G,
        activeIndex: Z,
        onNavigate: q
    }), {getReferenceProps: Y, getFloatingProps: $, getItemProps: _} = v([ U, V, W, X ]), ee = y([ S.setReference, E ]), te = B ? "ul" : "div", ne = K && e(F, {
        context: T,
        modal: !1,
        initialFocus: 0,
        returnFocus: !0,
        children: t("div", {
            ref: S.setFloating,
            className: "overflow-hidden rounded-xl border bg-white shadow-sm outline-none",
            style: {
                zIndex: C,
                position: Q,
                top: L ?? 0,
                left: J ?? 0
            },
            ...$(),
            children: [ m, !!o?.length && e(te, {
                className: "p-xs grid",
                children: o.map(((t, n) => {
                    const o = a(t) && u(t, _({
                        className: N(t.props.className, "focus-visible:bg-neutral-200 hover:bg-neutral-200 hover:outline-[#0F8FFF] focus-visible:outline focus-visible:outline-[#0F8FFF] outline-none py-[10px] px-s typography-body font-medium text-left rounded-lg w-full", R),
                        key: n,
                        role: B ? void 0 : "menuitem",
                        tabIndex: Z === n ? 0 : -1,
                        ref(e) {
                            G.current[n] = e;
                        },
                        onClick(e) {
                            t.props.onClick?.(e), H(!1);
                        },
                        onKeyDown(e) {
                            if (" " === e.key) {
                                e.preventDefault();
                                const t = e.target;
                                t?.click?.();
                            }
                        },
                        onMouseEnter() {
                            q(n);
                        }
                    }));
                    return o ? B ? e("li", {
                        tabIndex: -1,
                        children: o
                    }) : o : null;
                }))
            }), c ]
        })
    }), oe = Y(D);
    return t(n, {
        children: [ e("button", {
            ref: ee,
            ...oe,
            "aria-haspopup": B ? "true" : "menu"
        }), p ? e(w, {
            children: ne
        }) : ne ]
    });
}));

export { C as default };
//# sourceMappingURL=index.js.map
